import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { useHandleUnlockEmails } from '@aibees/elephant/feature/search-table-people/components/people-email-popover/hooks/use-handle-unlock-emails';
import { getLastVerificationDate } from '@aibees/elephant/feature/search-table-people/components/people-email-popover/utils';
import { fToNow } from '@aibees/shared/utils';
import { useMemo } from 'react';

export function useEmailEnrichmentDescriptionText(data?: PeopleTableInfo) {
  const { getItemState } = useActionButtonContext();
  const { unlocked, loading } = useHandleUnlockEmails(data);
  const lastUpdate = getLastVerificationDate(data?.revelation?.email);

  const emailEnrichmentProcessState = getItemState({
    id: data?.id || '',
    type: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
  }) as
    | ProcessingItemState.UNLOCKING
    | ProcessingItemState.UPDATING
    | ProcessingItemState.CHECKING_FOR_UPDATE
    | ProcessingItemState.REVERIFYING;

  const desc = {
    [ProcessingItemState.UNLOCKING]: 'Verifying email data...',
    [ProcessingItemState.REVERIFYING]: 'Re-verifying...',
    [ProcessingItemState.UPDATING]: 'Updating...',
    [ProcessingItemState.CHECKING_FOR_UPDATE]: 'Checking for updates...',
  };

  const loadingText =
    desc[emailEnrichmentProcessState ?? ProcessingItemState.UNLOCKING];

  return useMemo(
    () =>
      loading
        ? loadingText
        : unlocked
        ? `Last updated ${fToNow(lastUpdate, { strict: false })}`
        : 'Unlock to reveal email',
    [loading, loadingText, unlocked, lastUpdate]
  );
}
